module.exports = __webpack_public_path__ + "910425a4fbf5cfec7e6531721c908221.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/RePanda_BG.png
// module id = 5
// module chunks = 0